import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Title } from '../style';
import { HtmlRaw, Text } from '../../../atoms';
import CustomCarousel from '../../CustomCarousel';
import {
  CategoryCard,
  Cover,
  Overlay,
  CategoryCarouselWrapper,
  CategorySection,
} from './style';
import { Settings } from './settings';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';

const CategoryCarousel = ({ data, title, body, mediaIsPhone }) => {
  //? workaround to limit the number of dots visible @mobile
  useEffect(() => {
    const dots = document.querySelector('.slick-dots');
    const arrows = document.querySelectorAll('.slick-arrow');
    arrows.forEach((a, i) => {
      a?.addEventListener('click', () => {
        const scrollBy = i === 1 ? 30 : -30;
        dots.scrollBy({ left: scrollBy, top: 0, behavior: 'smooth' });
      });
    });
  }, []);

  return (
    <CategorySection>
      <div className="text-container">
        <Title>{title}</Title>
        <Text type="b3" mb={24}>
          <HtmlRaw html={body} />
        </Text>
      </div>
      {data?.length > 0 && (
        <CategoryCarouselWrapper>
          <CustomCarousel config={Settings}>
            {(data || []).map((item, i) => (
              <CategoryCard key={`category-${i}`}>
                <Cover src={item?.cover}>
                  <Overlay />
                </Cover>
                <div className="card-body">
                  <Text type="h3" mb={12}>
                    {item?.label}
                  </Text>
                  {/*
                  <Text type="b2" className="body">
                    <HtmlRaw html={item?.description} />
                  </Text>
                  */}
                </div>
              </CategoryCard>
            ))}
          </CustomCarousel>
        </CategoryCarouselWrapper>
      )}
    </CategorySection>
  );
};

CategoryCarousel.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  body: PropTypes.string,
  // HOC (connect, state)
  mediaIsPhone: PropTypes.bool,
};

export default connect()(withMediaQueries(CategoryCarousel));
